﻿export class RestaurantUserLoginModel {
  eMail: string;
  password: string;
}
